/* eslint-disable */
import TourProductsSortedRepository from "@/js/common/Domain/Repository/TourProductsSorted";

let TourProductsSortedHotelRepository = TourProductsSortedRepository.extend({
	comparator(model1, model2) {
		let currentSortStrategy = this.tourSearchModel.get('sortStrategy'),
			sortByValue = 0;

		switch (currentSortStrategy) {
			case "identity":
				sortByValue = this.tourSearchModel.get('selectedIdentity');
				break;
			case "operators":
			case "roomTypes":
			case "airLines":
				sortByValue = this.tourSearchModel.get('selectedSortValue');
		}

		return this.strategies[currentSortStrategy](model1, model2, sortByValue);
	},
	initialize(options, tourSearchModel){
		this.tourSearchModel = tourSearchModel
	}
});

export default TourProductsSortedHotelRepository